// extracted by mini-css-extract-plugin
module.exports = {"root":"BindsRow_root__2YRlr","sm":"BindsRow_sm__2VUCz","md":"BindsRow_md__HHoaB","lg":"BindsRow_lg__3oyNi"};